export default __webpack_public_path__ + "static/media/privacy-policy-kr-4.71f8e410.jpg";